import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    hasLogin: false,
    userInfo: JSON.parse(localStorage.getItem('userInfo') || "{}") || {},
    openId: '',
    config: {},
    orgInfo: {},
    domain:'',
    follow:localStorage.getItem('follow') || ''
  },
  getters: {
    userInfo (state) {
      return state.userInfo
    },
    openId (state) {
      return state.openId
    },
    hasLogin (state) {
      return state.hasLogin
    },
    config (state) {
      return state.config
    },
    orgInfo (state) {
      return state.orgInfo
    },
    domain(state) {
      return state.domain
    },
    follow(state) {
      return state.follow
    }
  },
  mutations: {
    login (state, provider) {
     return new Promise((resolve,reject)=> {
      state.hasLogin = true
      state.userInfo = provider
      localStorage.setItem('userInfo',JSON.stringify(provider))
      resolve()
     })
    },
    logout (state) {
      state.hasLogin = false
      state.userInfo = {}
    },
    setOpenId (state, openId) {
      state.openId = openId
    },
    setConfig (state, config) {
      state.config = config
    },
    setOrgInfo (state, orgInfo) {
      state.orgInfo = orgInfo
    },
    setdomain(state,domain) {
      state.domain = domain
    },
    setFollow(state,domain) {
      state.follow = domain
      localStorage.setItem("follow",domain);
    },
    
  },
  actions:{
  }
})

export default store
